<button mat-fab color="primary" class="allaction-btn" type="button" [matMenuTriggerFor]="menu">
    <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #menu="matMenu">
    <button mat-menu-item (click)="shareFile()">
        <mat-icon>share</mat-icon>Share
    </button>
    <button mat-menu-item>
        <mat-icon>cloud_download</mat-icon>Download
    </button>
    <button mat-menu-item>
        <mat-icon>file_copy</mat-icon>Copy
    </button>
    <button mat-menu-item>
        <mat-icon>open_in_new</mat-icon> Move
    </button>
    <button mat-menu-item class="text-danger" (click)="deleteDoc()" *ngIf="pageName != 'share'">
        <mat-icon class="text-danger">delete_outline</mat-icon> Delete
    </button>
</mat-menu>